import { API_CONSTANTS } from "../constants";

interface QAPair {
  question: string;
  answer: string;
}

export async function fetchClaudeQuickSummary(
  answeredQuestions: QAPair[],
  getUserToken?: () => string
) {
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };
  if (getUserToken) {
    const token = getUserToken();
    if (token) headers["Authorization"] = `token ${token}`;
  }

  const response = await fetch(
    `${API_CONSTANTS.apiURL}bren_erp.v8.api.get_claude_summary`,
    {
      method: "POST",
      headers,
      credentials: "include",
      body: JSON.stringify({ qa_pairs: answeredQuestions }),
    }
  );

  if (!response.ok) {
    throw new Error("Failed to fetch summary from Claude API");
  }

  const data = await response.json();
  return (data?.message?.summary || data?.data?.summary || "").trim();
}
